import { type LicenseLogo } from "./getLicenseLogos"

type EmbedTheme = "light" | "dark" | "auto"
type EmbedSize = "sm" | "md" | "lg"

type EmbedSnippetOptions = {
  logos: LicenseLogo[]
  licenseName: string
  licenseCode?: string
  theme: EmbedTheme
  size: EmbedSize
}

const EMBED_BASE = "https://license-builder.adbex.org"
export const EMBED_SCRIPT_URL = `${EMBED_BASE}/embed/license-widget.min.js`

const escapeAttribute = (value: string) =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")

export const generateEmbedSnippet = ({
  logos,
  licenseName,
  licenseCode,
  theme,
  size
}: EmbedSnippetOptions) => {
  if (!logos.length) return "<!-- No license logos available for embedding -->"

  const logoKeys = logos.map(logo => logo.key).join(",")
  const variant = logos[0]?.variant ?? "color"
  const attrs = [
    `class="adbex-license-widget"`,
    `data-license-name="${escapeAttribute(licenseName)}"`,
    `data-logos="${escapeAttribute(logoKeys)}"`,
    `data-variant="${escapeAttribute(variant)}"`,
    `data-theme="${escapeAttribute(theme)}"`,
    `data-size="${escapeAttribute(size)}"`
  ]

  if (licenseCode && licenseCode !== "std") {
    attrs.push(`data-license-code="${escapeAttribute(licenseCode)}"`)
  }

  return `<script async src="${EMBED_SCRIPT_URL}"></script>\n<div ${attrs.join(" ")}></div>`
}
